const audi = {
  appConfig: {
    brandName: 'audi',
    language: 'de-DE',
    isCarTypeSelectionEnabled: false
  }
};

export default audi;
